// src/plugins/session-storage.js
// Vue 3 compatible session storage plugin

class SessionStorage {
  set(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
      return true;
    } catch (error) {
      // SessionStorage set error
      return false;
    }
  }

  get(key) {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      // SessionStorage get error
      return null;
    }
  }

  exists(key) {
    return sessionStorage.getItem(key) !== null;
  }

  remove(key) {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      // SessionStorage remove error
      return false;
    }
  }

  clear() {
    try {
      sessionStorage.clear();
      return true;
    } catch (error) {
      // SessionStorage clear error
      return false;
    }
  }

  key(index) {
    return sessionStorage.key(index);
  }

  get length() {
    return sessionStorage.length;
  }
}

export default {
  install(app) {
    const sessionStorageInstance = new SessionStorage();

    // Make it available as $session in components
    app.config.globalProperties.$session = sessionStorageInstance;

    // Also provide it for composition API
    app.provide('session', sessionStorageInstance);
  }
};
